<template>
    <rkm-area
        no-margin-top
        title="Procedimentos - EMAD"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-list
                    :items="item.plano.procedimentosEmad"
                    hide-filters
                    hide-pagination
                >
                    <template v-slot="{item}">
                        <rkm-row>
                            <rkm-col cols="8">
                                <Item
                                    :get-value="() => `${formatProcedimento(item.codigo)} - ${item.nome}`"
                                    label="Procedimento"
                                />
                            </rkm-col>
                        </rkm-row>
                    </template>
                </rkm-list>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

// Mixins.
import {formats} from '@/mixins'

export default {
    components: {Item},
    mixins: [formats],
    props: {
        item: {type: Object, required: true},
    },
}
</script>